import React from "react";

const Loader = () => {
  return (
    <div id="loader-wrapper">
      <div id="loader"></div>
    </div>
  );
};

export default Loader;
